export default __webpack_public_path__ + "static/media/private_bg_m.0acbfe9f.png";